// Bandeau cookies : le choix du visiteur (accepter / refuser), gardé 6 mois dans son navigateur.
// La balise Google Analytics d'Amine (G-RKPJV4EKSD) est dans index.html telle quelle (R-46) ; ce fichier dit seulement
// quand elle a le droit de poser ses cookies (« Accepter ») ; sans accord, elle compte la visite sans cookie (R-110).
const CLE = 'cogetrans-cookies'
const SIX_MOIS = 182 * 24 * 3600 * 1000

export type Choix = 'accepte' | 'refuse'

export function choixGarde(): Choix | null {
  try {
    const v = JSON.parse(localStorage.getItem(CLE) || 'null') as { choix: Choix; date: number } | null
    return v && Date.now() - v.date < SIX_MOIS ? v.choix : null
  } catch { return null }
}

export function garderChoix(choix: Choix) {
  try { localStorage.setItem(CLE, JSON.stringify({ choix, date: Date.now() })) } catch { /* navigation privée : on redemandera */ }
  if (choix === 'refuse') {
    // Refus après un accord : on efface les cookies de mesure déjà posés.
    document.cookie.split(';').map(c => c.trim().split('=')[0]).filter(n => n.startsWith('_ga')).forEach(n => {
      document.cookie = `${n}=; Max-Age=0; path=/; domain=.${location.hostname}`
      document.cookie = `${n}=; Max-Age=0; path=/`
    })
  }
  // La balise Google lit ce choix (mode consentement, public/consentement-defaut.js).
  const g = (window as unknown as { gtag?: (...a: unknown[]) => void }).gtag
  g?.('consent', 'update', { analytics_storage: choix === 'accepte' ? 'granted' : 'denied' })
  window.dispatchEvent(new CustomEvent('cogetrans-consentement', { detail: choix }))
}

// Le lien « Gérer les cookies » du bas de page rouvre le bandeau.
export const rouvrirBandeau = () => window.dispatchEvent(new Event('cogetrans-cookies-ouvrir'))
